import React from 'react';
import { Box, Typography } from '@mui/material';
import { useThemeContext } from '../contexts/BaseThemeContextProvider';
import QuestionnairesTable from './QuestionnairesTable';

const RecordsPage = () => {
  const { theme } = useThemeContext();
  const pageBg = theme.layout.defaults.backgroundColor;
  const recordsTheme = theme.custom.pages.frost.records;

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        backgroundColor: pageBg,
        padding: { xs: '20px', sm: '40px' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', md: 'flex-end' },
          gap: 2,
          mb: 4,
        }}
      >
        <Box>
            <Typography variant="h4" sx={{ fontWeight: 700, color: recordsTheme.header.title, mb: 1 }}> 
                Records
            </Typography>
        </Box>
      </Box>

      <QuestionnairesTable />

    </Box>
  );
};

export default RecordsPage;
